import React from 'react';

/* eslint-disable import/no-unresolved */
import DirectionsWalkOutlined from '../../images/maps/svg_icons/directions_walk.svg?react'; // @material-design-icons/svg/outlined/
import BusIcon from '../../images/maps/svg_icons/bus.svg?react';
import DrtShuttleIcon from '../../images/maps/svg_icons/drt-shuttle.svg?react';
import RegionalTrainIcon from '../../images/maps/svg_icons/regio.svg?react';
import SuburbanTrainIcon from '../../images/maps/svg_icons/s-bahn.svg?react';
import LongDistanceTrainIcon from '../../images/maps/svg_icons/train.svg?react';
import TramIcon from '../../images/maps/svg_icons/tram.svg?react';
import UndergroundIcon from '../../images/maps/svg_icons/u-bahn.svg?react';

import { formatDateToTime } from '../../lib/dateTimeHelpers';
/* eslint-enable import/no-unresolved */

export const withStationLink = (location) => {
  if (!location) {
    return null;
  }

  const locationInfo = location.location_name || location.formatted_street;

  if (location.station_id) {
    return (
      <a href={`../stations/${location.station_id}`}>
        <span className="text-truncate">{locationInfo}</span>
      </a>
    );
  }

  if (locationInfo) {
    return <span className="d-flex text-truncate">{locationInfo}</span>;
  }

  return (
    <span
      className="d-flex text-truncate"
      title={`${location.lat.toFixed(3)} ${location.lng.toFixed(3)}`}
    >
      no address
    </span>
  );
};

export const EMPTY_TOKEN = '–';
const isEmpty = (value) => !value;

export const renderPlaceholderIfEmpty = (
  value, // value to check if empty
  displayValue, // value to display in the ui if not empty
  placeholder = EMPTY_TOKEN
) => {
  if (isEmpty(value)) return placeholder;
  return isEmpty(displayValue) ? value : displayValue;
};

export const getTransportModeIcon = (
  transportMode,
  transportType,
  width = 20
) => {
  if (transportType) {
    return {
      bus: <img width={width} src={BusIcon} alt="bus" />,
      long_distance_train: <img width={width} src={LongDistanceTrainIcon} alt="long distance train" />,
      regional_train: <img width={width} src={RegionalTrainIcon} alt="regional train" />,
      suburban_train: <img width={width} src={SuburbanTrainIcon} alt="suburban train" />,
      tram: <img width={width} src={TramIcon} alt="tram" />,
      underground: <img width={width} src={UndergroundIcon} alt="underground" />
    }[transportType];
  }

  return {
    drt: <img width={width} src={DrtShuttleIcon} alt="shuttle" />,
    walk: <img className="fill-ioki-gray-5" style={{ width }} src={DirectionsWalkOutlined} alt="walk" />,
    public_transport: undefined // will be handled by the transportType condition above
  }[transportMode];
};

export const getHopColor = (
  transportMode,
  transportType
) => {
  if (transportType) {
    return {
      bus: '#A3007C',
      long_distance_train: '#E30613',
      regional_train: '#E30613',
      suburban_train: '#006F35',
      tram: '#0008D8',
      underground: '#0080C8'
    }[transportType];
  }

  return {
    drt: '#d11064', // ioki-accent
    walk: '#1e293b', // ioki-gray-8
    public_transport: undefined // will be handled by the transportType condition above
  }[transportMode];
};

export const getHopAddress = (
  transportMode,
  from,
  to
) =>
  ({
    walk: {
      fromAddress: from.formatted_street || from.location_name,
      toAddress: to.formatted_street || to.location_name
    },
    drt: {
      fromAddress: withStationLink(from),
      toAddress: withStationLink(to)
    },
    public_transport: {
      fromAddress: from.location_name,
      toAddress: to.location_name
    }
  })[transportMode];

export const getHopTime = (
  transportMode,
  from,
  to
) => {
  const { display_times: fromDisplayTimes } = from;
  const { display_times: toDisplayTimes } = to;

  const calculatedPointFromTime =
    fromDisplayTimes[0] ||
    from.time ||
    from.scheduled_departure;

  const calculatedPointFromTimeFormatted =
    calculatedPointFromTime && formatDateToTime(calculatedPointFromTime);

  const calculatedPointToTime = toDisplayTimes[0];

  const calculatedPointToTimeFormatted =
    calculatedPointToTime && formatDateToTime(calculatedPointToTime);

  const publicTransportFromTime =
    fromDisplayTimes[0] || (from).scheduled_departure;

  const publicTransportFromTimeFormatted =
    publicTransportFromTime && formatDateToTime(publicTransportFromTime);

  const publicTransportToTime = toDisplayTimes[0] || to.scheduled_arrival;

  const publicTransportToTimeFormatted =
    publicTransportToTime && formatDateToTime(publicTransportToTime);

  return {
    walk: {
      fromTime: calculatedPointFromTimeFormatted,
      toTime: calculatedPointToTimeFormatted
    },
    drt: {
      fromTime: calculatedPointFromTimeFormatted,
      toTime: calculatedPointToTimeFormatted
    },
    public_transport: {
      fromTime: publicTransportFromTimeFormatted,
      toTime: publicTransportToTimeFormatted
    }
  }[transportMode];
};
